import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import Layout from '../components/Layout';

const Communications = () => {
  const [messages, setMessages] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [activeTab, setActiveTab] = useState('inbox');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
    fetchTemplates();
  }, []);

  const fetchMessages = async () => {
    try {
      const { data } = await supabase
        .from('messages')
        .select('*')
        .order('created_at', { ascending: false });
      setMessages(data || []);
    } catch (error) {
      console.log('Messages table not found, using empty array');
      setMessages([]);
    }
    setLoading(false);
  };

  const fetchTemplates = async () => {
    try {
      const { data } = await supabase
        .from('communication_templates')
        .select('*')
        .order('created_at', { ascending: false });
      setTemplates(data || []);
    } catch (error) {
      console.log('Templates table not found, using empty array');
      setTemplates([]);
    }
  };

  const markAsRead = async (messageId) => {
    await supabase
      .from('messages')
      .update({ status: 'read' })
      .eq('id', messageId);
    fetchMessages();
  };

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
      <h2>Communication & Service Portal</h2>
      
      <div style={{ display: 'flex', gap: '20px', marginBottom: '30px' }}>
        <button 
          onClick={() => setActiveTab('inbox')}
          className={`btn ${activeTab === 'inbox' ? 'btn-primary' : 'btn-secondary'}`}
        >
          Multi-Channel Inbox
        </button>
        <button 
          onClick={() => setActiveTab('templates')}
          className={`btn ${activeTab === 'templates' ? 'btn-primary' : 'btn-secondary'}`}
        >
          Templates
        </button>
        <button 
          onClick={() => setActiveTab('documents')}
          className={`btn ${activeTab === 'documents' ? 'btn-primary' : 'btn-secondary'}`}
        >
          Documents
        </button>
        <button 
          onClick={() => setActiveTab('surveys')}
          className={`btn ${activeTab === 'surveys' ? 'btn-primary' : 'btn-secondary'}`}
        >
          Surveys & Reviews
        </button>
      </div>

      {activeTab === 'inbox' && (
        <div>
          <h3>Multi-Channel Inbox</h3>
          {loading ? (
            <p>Loading messages...</p>
          ) : (
            <div style={{ display: 'grid', gap: '15px' }}>
              {messages.map(message => (
                <div 
                  key={message.id}
                  style={{ 
                    background: message.status === 'unread' ? '#f0f8ff' : 'white',
                    border: '1px solid #ddd',
                    borderRadius: '8px',
                    padding: '15px'
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <strong>{message.subject}</strong>
                      <p style={{ margin: '5px 0', color: '#666' }}>
                        Channel: {message.channel || 'portal'}
                      </p>
                    </div>
                    {message.status === 'unread' && (
                      <button 
                        onClick={() => markAsRead(message.id)}
                        className="btn btn-primary"
                        style={{ fontSize: '12px', padding: '5px 10px' }}
                      >
                        Mark Read
                      </button>
                    )}
                  </div>
                  <p style={{ marginTop: '10px' }}>{message.content}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeTab === 'templates' && (
        <div>
          <h3>Email & SMS Templates</h3>
          <div style={{ display: 'grid', gap: '15px' }}>
            {templates.map(template => (
              <div key={template.id} style={{ background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '15px' }}>
                <h4>{template.name}</h4>
                <p><strong>Type:</strong> {template.type}</p>
                {template.subject && <p><strong>Subject:</strong> {template.subject}</p>}
                <p><strong>Content:</strong> {template.content}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {activeTab === 'documents' && (
        <div>
          <h3>Online Documents</h3>
          <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
            <p>Document management system for leases, agreements, and forms.</p>
            <button className="btn btn-primary">Upload Document</button>
          </div>
        </div>
      )}

      {activeTab === 'surveys' && (
        <div>
          <h3>Resident Surveys & Reviews</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
            <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
              <h4>Create Survey</h4>
              <button className="btn btn-primary">New Survey</button>
            </div>
            <div style={{ background: 'white', border: '1px solid #ddd', borderRadius: '8px', padding: '20px' }}>
              <h4>Recent Reviews</h4>
              <p>View resident feedback and ratings</p>
            </div>
          </div>
        </div>
      )}
      </div>
    </Layout>
  );
};

export default Communications;